import { http, useAPI } from '~~core';

import { cafCredentialsSchema, livenessEvidenceSaveResponsSchema, bimetricStatusResponseSchema } from '../schemas/caf';

type CAFEvidence = {
  jwt: string
};

export type CAFRequirementsTypes = 'liveness' | 'biometric';

export async function fetchCAFCredentials(signatureRequestKey: string) {
  const { getEndpoint } = useAPI(signatureRequestKey);

  const data = await http(getEndpoint('caf/tokens'));

  return cafCredentialsSchema.parse(data);
}

export async function saveCAFEvidence(requirement: CAFRequirementsTypes, signatureRequestKey: string, { jwt }: CAFEvidence) {
  const { getEndpoint } = useAPI(signatureRequestKey);

  const data = await http(getEndpoint(`${requirement}`), {
    method: 'POST',
    body: {
      [requirement]: { signedResponse: jwt },
    },
  });

  return livenessEvidenceSaveResponsSchema.parse(data);
}

export async function fetchBiometricStatus(signatureRequestKey: string) {
  const { getEndpoint } = useAPI(signatureRequestKey);

  const data = await http(getEndpoint('biometric'));

  return bimetricStatusResponseSchema.parse(data);
}

export async function rejected(signatureRequestKey: string) {
  await http(`/notarial/widget/signatures/${signatureRequestKey}/biometric/reject`, {
    method: 'PUT',
  });
}
